import type { GridColDef } from '@mui/x-data-grid';

import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import { dateUtils } from '@/utils/date';

export const columns = (): GridColDef[] => [
    {
        field: 'code',
        headerName: 'Mã',
        minWidth: 200,
        flex: 1,
        sortable: false,
        renderCell: ({ row }) => <HoverCopyCell value={row.code} />,
    },
    {
        field: 'name',
        headerName: 'Tên hành vi',
        editable: false,
        sortable: false,
        minWidth: 300,
        flex: 1,
        renderCell: (params: any) => <HoverCopyCell value={params.row.name} />,
    },
    {
        field: 'violationType',
        headerName: 'Loại hành vi',
        minWidth: 300,
        flex: 1,
        sortable: false,
        renderCell: ({ row }) => (
            <HoverCopyCell value={row.violationType?.name || '-:-'} />
        ),
    },
    {
        field: 'description',
        headerName: 'Mô tả',
        editable: false,
        sortable: false,
        minWidth: 300,
        flex: 1,
        renderCell: ({ row }) => (
            <HoverCopyCell value={row.description || '-:-'} />
        ),
    },
    {
        field: 'createdDate',
        headerName: 'Ngày tạo',
        editable: false,
        sortable: true,
        minWidth: 150,
        flex: 1,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => (
            <HoverCopyCell value={dateUtils.getDate(params.value)} />
        ),
    },
];
